import { initialize } from "@/api";
import { TokenService } from "@/api/storage";
import { getLoginRouteFromRole } from "@/mixins/LogoutMixin";
import Vue from "vue";
import VueRouter from "vue-router";
import Store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home/:user/:language?",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeAdmin.vue"),
    meta: {
      displayName: "displayName.home",
      requiresAuth: false,
    },
  },
  {
    path: "/home-admin/:user/:language?",
    name: "homeAdmin",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeAdmin.vue"),
    meta: {
      displayName: "displayName.homeAdmin",
      requiresAuth: false,
    },
  },
  {
    path: "/auth-pessoa/:user/:language?",
    name: "homeUser",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Onboarding.vue"),
    meta: {
      displayName: "displayName.homeUser",
      requiresAuth: false,
    },
  },
  {
    path: "/pagina-nao-encontrada",
    name: "notFound",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/NotFound.vue"),
    meta: {
      displayName: "displayName.notFound",
      requiresAuth: false,
    },
  },
  {
    path: "/pagina-sem-autenticacao",
    name: "notAuth",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/NotAuth.vue"),
    meta: {
      displayName: "displayName.notFound",
      requiresAuth: false,
    },
  },
  {
    path: "/onboarding/:user/:language?",
    name: "onboarding",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeUser.vue"),
    meta: {
      displayName: "displayName.onboarding",
      requiresAuth: false,
    },
  },
  {
    path: "/auth-empresa/:user/:language?",
    name: "onboardingAdmin",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/OnboardingAdmin.vue"),
    meta: {
      displayName: "displayName.onboardingAdmin",
      requiresAuth: false,
    },
  },
  {
    path: "/pagina-sem-permissao",
    name: "withoutPermission",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/WithoutPermission.vue"),
    meta: {
      displayName: "displayName.notFound",
      requiresAuth: false,
    },
  },
  {
    path: "/submissao-case/:language?",
    name: "submitCasePublic",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SubmitCase.vue"),
    meta: {
      displayName: "Submissão case - Exclusive Lounge",
      requiresAuth: false,
    },
  },
  {
    path: "/transparencia-dados",
    name: "transparency",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Transparency.vue"),
    meta: {
      displayName: "displayName.transparency",
      requiresAuth: true,
      title: "Exclusive Lounge",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const token = TokenService.getToken();
  const firstAccess = TokenService.getFirstAccess();
  const localRole = TokenService.getRole();
  if (from.name && !Store.state.isGoingBack) {
    Store.commit("pushNavigation", {
      name: from.name,
      params: from.params ? { ...from.params } : undefined,
      query:
        from.query && Object.keys(from.query).length > 0
          ? { ...from.query }
          : undefined,
    });
  }
  Store.commit("setGoingBack", false);
  if (to.matched.length === 0) {
    next("/pagina-nao-encontrada");
  } else if (to?.meta?.requiresAuth) {
    // redirect to login if the user to try acess any other route without login
    if (!TokenService.getToken()) {
      Store.dispatch("updateRouteAfterLogin", to);
      const storeRole = (Store as any).state?.profile?.me?.role || localRole;
      next({ name: getLoginRouteFromRole(storeRole) });
    } else {
      initialize();
      const isReturn =
        [
          "searchHome",
          "timelineHome",
          "readingListHome",
          "profileCLevel",
          "profileMarketing",
          "profileHome",
        ].includes(`${to.name}`) &&
        [
          "profileCLevel",
          "profileMarketing",
          "timelinePost",
          "communityHome",
          "searchTagId",
          "roundTableItems",
          "newPostRoundTable",
          "communityMembersHome",
        ].includes(`${from.name}`) &&
        (Store.state.lastItemsPost.length > 0 ||
          Store.state.lastItemsUser.length > 0);
      Store.dispatch("updateReturn", isReturn);
      const SEARCH_RETURN_FROM = [
        "timelinePost",
        "profileCLevel",
        "profileMarketing",
        "communityHome",
        "roundTableItems",
        "newPostRoundTable",
        "communityMembersHome",
      ];
      const isReturnSearch =
        to.name === "searchHome" && SEARCH_RETURN_FROM.includes(`${from.name}`);
      Store.dispatch("updateSearchReturn", isReturnSearch);
      if (from.name === "searchHome") Store.dispatch("updateFilter", "");

      next();
    }
  } else if (
    token &&
    firstAccess !== "true" &&
    to.name !== "submitCasePublic"
  ) {
    initialize();
    next({ name: "timelineHome" });
  } else {
    const isLoginPage =
      to.name === "loginUserPage" || to.name === "loginCompanyPage";
    if (!token && isLoginPage) {
      Store.dispatch("onboarding/requestLogout", false);
    }
    next();
  }
  if (window.location.hostname === "admin.exclusivelounge.network") {
    window.location.href = `https://exclusivelounge.network${window.location.pathname}${window.location.search}`;
    return;
  }
  next();
});

export default router;
